//Vue components
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//Functions
import axios from 'axios'

//Design, UI
import './../node_modules/bulma/css/bulma.css';
import Clipboard from 'v-clipboard'
import VueApexCharts from 'vue-apexcharts'


//Localization
import VueI18n from 'vue-i18n'
import CountryFlag from 'vue-country-flag'
import { languages } from './lang/localisation.js'
import { defaultLocale } from './lang/localisation.js'
import { fallbackLocale } from './lang/localisation.js'

import * as VueGoogleMaps from 'vue2-google-maps'


const messages = Object.assign(languages)

Vue.use(VueI18n)
var supportedLanguages = [];
for (var lang in messages) supportedLanguages.push(lang);

Vue.prototype.$axios = axios

Vue.config.productionTip = false

Vue.prototype.$supportedLanguages = supportedLanguages;
Vue.prototype.$allowedUnauthenticatedRoutes = ['login', 'register', 'impressum', 'feedback']
Vue.prototype.$adminRoutes = ['createUser', 'vouchers', 'administration']
Vue.prototype.$backendURL = process.env.VUE_APP_backendBaseUrl
Vue.prototype.$storageURL = process.env.VUE_APP_backendStorageUrl

Vue.prototype.$showLocalisation = false;

Vue.prototype.testApiCall = async function() {

        var promise = new Promise(function(resolve, reject) {
            setTimeout(() => {
                resolve("Waited for 4 seconds");

            }, 4000);

            //   reject(Error("It broke"));

        });
        return promise;
    }
    /**
     * type: post/get
     * endpoint: url
     * header: json
     * payload: data
     * 
     * Calls an api. Used for communication with backend, so that we dont need to add the authorization-header manually on
     * every request.
     */
Vue.prototype.callApi = async function(endpoint, type = 'get', payload = {}, header = null, showError = true, customEndpoint = false) {

    var promise = new Promise(function(resolve, reject) {
        let headerData = header;

        //Only add authorization-header when backend is called
        if (header == null && !customEndpoint) {
            headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }
        }
        let apiUrl = Vue.prototype.$backendURL + endpoint;
        if (customEndpoint) {
            apiUrl = endpoint
        }
        if (type == 'post') {
            Vue.prototype.$axios.post(apiUrl, payload, {
                headers: headerData
            }).then(function(result) {
                Vue.prototype.checkForError(result)
                resolve(result);

            }.bind(this)).catch(function(error) {

                Vue.prototype.checkForError(error, 'server')

                reject(error);
            }.bind(this))
        } else {
            Vue.prototype.$axios.get(apiUrl, {
                headers: headerData
            }).then(function(result) {
                Vue.prototype.checkForError(result)

                resolve(result);

            }.bind(this)).catch(function(error) {
                reject(error);
                Vue.prototype.checkForError(error, 'server')

            }.bind(this))
        }

    }.bind(this));
    return promise;
}


Vue.prototype.sendInfoMessage = function(data) {
    this.$root.$emit('sendInfoMessage', data)
}

Vue.component('apexchart', VueApexCharts)
Vue.component('country-flag', CountryFlag)

const i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: fallbackLocale,
    messages
})


//Prüfe ob der Nutzer eingeloggt ist oder eine Seite besucht die dies nicht benötigt. Ansonsten weiterleitung zur Loginseite.
//Setzt außerdem den Nutzernamen (VueX)
//Prüfung bei jedem Seitenaufruf, sowohl direkt per URL als auch per Link
router.beforeEach((to, from, next) => {
    router.app.$emit('pageclick', null)
    router.app.$emit('navigationChange', null)

    if (Vue.prototype.$allowedUnauthenticatedRoutes.includes(to.name)) {
        next();
    } else {
        let checkLogin = new Promise((resolve, reject) => {
            if (localStorage.bearertoken == "") {
                reject("no token")
            }
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }
            axios.get(Vue.prototype.$backendURL + "/user", { headers: headerData }).then(
                function(response) {
                    console.log("Vue.router.beforeEach - Ok: Got userdata from /user")

                    resolve(response)
                }
            ).catch(function(error) {
                console.log("Vue.router.beforeEach - Error: " + JSON.stringify(error))
                reject(error);
            });
        });
        checkLogin.then(function(response) {
            store.commit('setUsername', response.data.firstname)
            store.commit('setUser', response.data)
            store.commit('setNewMessage', response.data.newmessages)
            if ((Vue.prototype.$adminRoutes.includes(to.name) && store.getters.getUser.role >= 2) ||
                !Vue.prototype.$adminRoutes.includes(to.name)) {
                next();
            } else {
                store.commit('setUsername', '')
                store.commit('setUser', '')
                next("/login");
            }
        }.bind(this)).catch(function(error) {

            console.log("CheckLogin Error: " + error)
            next("/login");
        }.bind(this));
    }
})


Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyA5GjrZCUkiOJYF76A3yp86Qgg68yeL96c',
        libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)


    },
    //installComponents: false

})



let vueInstance = new Vue({
    i18n,
    router,
    store,

    render: function(h) { return h(App) }
}).$mount('#app')

Vue.use(Clipboard);






//type: server(504,...) or data(wrong password,...) 
Vue.prototype.checkForError = function(error, type = "data") {
    console.log("in checkerror")
    if (type == 'server') {
        let errorcodes = {
            '401': 'Can\'t authorize on Server',
            '422': 'Invalid data: ' + JSON.stringify(error.response.data.errors),
            '500': 'Servererror'

        }
        let errormessage = errorcodes[error.response.status] || 'Servererror';
        // this.$root.$emit('sendInfoMessage', data)
        vueInstance.$emit('sendInfoMessage', { 'text': errormessage })

        //  Vue.prototype.sendInfoMessage({ 'text': errormessage });
    } else {
        console.log("errortype is not server")
        console.log("errorcode is " + JSON.stringify(error.data.code))
        if (error.data.code == 1 || error.data.code == "1" || error.data.code == undefined || error.data.code == null) {
            return true;
        }
        let errorcodes = {
            '2': 'Invalid Data given',
            '3': 'Unauthorized',
            '4': 'Duplicate entry',
            '5': 'You can only perform this as an Admin',
            '12': 'Some data is missing',
            '13': 'Error - ?',
            '14': 'User has not requestet to participate',
            '15': 'The room is not available',
            '16': 'The user does not participate and can not be removed',
            '17': 'Begin is after end',
            '18': 'User is already a member',
            '19': 'The event is full',
            '25': 'The ressouce is not available at this time',
            '31': 'Voucher',
            '32': 'Invalid voucher',
            '33': 'Voucher already used',
        }
        let errormessage = errorcodes[error.data.code] || 'Internal error';
        console.log("errormessage is " + errormessage)
        vueInstance.$emit('sendInfoMessage', { 'text': errormessage })


    }
    return false;
}